import { getLanguage } from "../i18n/withIntl.selectors";
import { RootState } from "./root.reducer";

export const getRtl = (state: RootState): boolean =>
  getLanguage(state).inversedDirection;
